import { toggleCustomerView } from 'actions/AgentHubActions'
import SwitchButton from 'LuxKit/Switch/SwitchButton'
import Tooltip from 'LuxKit/Tooltip'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import React, { useCallback } from 'react'

function AgentHubCustomerViewSwitch() {
  const customerViewEnabled = useAppSelector(state => state.agentHub.customerView)
  const dispatch = useAppDispatch()

  const handleChange = useCallback(() => {
    dispatch(toggleCustomerView())
  }, [dispatch])

  return (<Tooltip
    description="This will hide any commission when searching and viewing offers. Commission will show when purchasing any offer"
  >
    <SwitchButton
      checked={customerViewEnabled}
      onChange={handleChange}
    >
      Customer view
    </SwitchButton>
  </Tooltip>)
}

export default AgentHubCustomerViewSwitch
